import { Link } from "react-router-dom";
import { articles, categories } from "@/utils/news";

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
      {categories.map((cat) => {
        const count = articles.filter((item) => item.category === cat.key).length;
        return (
          <Link
            key={cat.key}
            to={`/category/${cat.key}`}
            className="group relative flex h-40 cursor-pointer flex-col justify-end overflow-hidden rounded-lg border border-background-200"
          >
            <img
              src={cat.cover}
              alt={`${cat.name}分类 - 51吃瓜网站`}
              title={`${cat.name} - 51吃瓜网站`}
              className="absolute inset-0 h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/35 to-transparent"></div>
            <div className="relative z-10 p-4">
              <h3 className="flex items-center gap-1.5 font-heading text-lg font-bold text-background-50">
                {cat.name}
                <i className="ri-arrow-right-up-line text-base text-primary-400 transition-transform group-hover:translate-x-0.5"></i>
              </h3>
              <p className="mt-1 text-xs text-background-200">{count} 篇精选资讯</p>
            </div>
          </Link>
        );
      })}
    </div>
  );
}